import { render } from "./GenerateApprovalPODialog.vue?vue&type=template&id=082b364e&scoped=true"
import script from "./GenerateApprovalPODialog.vue?vue&type=script&lang=ts"
export * from "./GenerateApprovalPODialog.vue?vue&type=script&lang=ts"

import "./GenerateApprovalPODialog.vue?vue&type=style&index=0&id=082b364e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-082b364e"

export default script